var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4 30H2.133C.955 30 0 29.105 0 28V2C0 .895.955 0 2.133 0H17.25c.566 0 1.109.21 1.51.585l8.349 7.83c.4.375.624.883.624 1.413V16",
    transform: "translate(8 9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.733 10H19.2c-1.178 0-2.133-.895-2.133-2V0M10.667 30c2.356 0 4.266-1.79 4.266-4v-2c0-2.21-1.91-4-4.266-4v10zM21.333 20c-1.178 0-2.133.895-2.133 2v6c0 1.105.955 2 2.133 2 1.179 0 2.134-.895 2.134-2v-6c0-1.105-.955-2-2.134-2h0zM32 20c-2.356 0-4.267 1.79-4.267 4v2c0 2.21 1.91 4 4.267 4",
    transform: "translate(8 9)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.0b15b137c6e69f29d143b25c6a9469bd.svg";
export { ForwardRef as ReactComponent };